import Axios from 'axios'

import Consts from '../../lib/Consts'

export default {
  namespaced: true,
  state: {
    accessToken: null,
    // staging以外の開発環境はそもそもWebページが動作しないので、とりあえず本番以外は全てstagingにしておく
    apiEndpoint: process.env['NODE_ENV'] === 'production' ? Consts.DEFAULT_API_ENDPOINT : Consts.STAGING_API_ENDPOINT,
    defaultApiEndpoint: process.env['NODE_ENV'] === 'production' ? Consts.DEFAULT_API_ENDPOINT : Consts.STAGING_API_ENDPOINT
  },
  getters: {
    isLoggedIn (state) {
      return state.accessToken !== null
    },
    apiEndpointIsDefault (state) {
      return state.apiEndpoint === state.defaultApiEndpoint
    }
  },
  mutations: {
    setAccessToken (state, { accessToken }) {
      state.accessToken = accessToken
    },
    setApiEndpoint (state, { apiEndpoint }) {
      state.apiEndpoint = apiEndpoint
    }
  },
  actions: {
    init ({ commit, state }) {
      const accessToken = localStorage.getItem(Consts.LS_KEY_ACCESS_TOKEN)
      if (accessToken) {
        commit('setAccessToken', { accessToken })
      }
      if (state.accessToken) {
        Axios.defaults.headers.common['Authorization'] = `Bearer ${state.accessToken}`
      }

      const apiEndpoint = localStorage.getItem(Consts.LS_KEY_API_ENDPOINT)
      if (apiEndpoint) {
        commit('setApiEndpoint', { apiEndpoint })
      }
      Axios.defaults.baseURL = state.apiEndpoint
    },

    login ({ commit, dispatch }, { accessToken }) {
      commit('setAccessToken', { accessToken })
      localStorage.setItem(Consts.LS_KEY_ACCESS_TOKEN, accessToken)
      Axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
      dispatch('serverConstants/fetch', null, { root: true })
    },

    logout ({ commit, dispatch }) {
      commit('setAccessToken', { accessToken: null })
      localStorage.removeItem(Consts.LS_KEY_ACCESS_TOKEN)
      delete Axios.defaults.headers.common['Authorization']
      dispatch('serverConstants/reset', null, { root: true })
    },

    resetApiEndpoint ({ commit, state }, { displayMessage = false }) {
      commit('setApiEndpoint', { apiEndpoint: state.defaultApiEndpoint })
      localStorage.removeItem(Consts.LS_KEY_API_ENDPOINT)
      Axios.defaults.baseURL = state.defaultApiEndpoint

      if (displayMessage) {
        console.info(`APIエンドポイントをデフォルトに戻しました。(${state.configurations.defaultApiEndpoint})`)
      }
    },

    updateApiEndpoint ({ commit, getters }, { apiEndpoint, displayMessage = false }) {
      if (getters.isLoggedIn) {
        console.error('ログイン中はエンドポイントを変更できません。エンドポイントを変更するには一度ログアウトしてください。')
        return
      }

      commit('setApiEndpoint', { apiEndpoint })
      localStorage.setItem(Consts.LS_KEY_API_ENDPOINT, apiEndpoint)
      Axios.defaults.baseURL = apiEndpoint

      if (displayMessage) {
        console.info(`APIエンドポイントを設定しました。(${apiEndpoint})`)
      }
    }
  }
}
